import { render, staticRenderFns } from "./ERegistrationRegisterSuccessView.vue?vue&type=template&id=d1f518e0&scoped=true&"
import script from "./ERegistrationRegisterSuccessView.vue?vue&type=script&lang=js&"
export * from "./ERegistrationRegisterSuccessView.vue?vue&type=script&lang=js&"
import style0 from "./ERegistrationRegisterSuccessView.vue?vue&type=style&index=0&id=d1f518e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f518e0",
  null
  
)

/* custom blocks */
import block0 from "./ERegistrationRegisterSuccessView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports